import { ICalculateStampDutyParams, IRuleMapping, ISearchContext } from "./interfaces";

export type IExceptionAssertion = (searchContext: ICalculateStampDutyParams) => boolean

const anyAdditionalPropertyUnder40k: IExceptionAssertion = (
  searchContext,
) => (
  searchContext.isOnlyProperty === false
    && searchContext.propertyValue! < 40_000);

const noCharge: any = {
  [Infinity]: 0,
};

const exceptions: Array<[IExceptionAssertion, IRuleMapping]> = [
  [
    anyAdditionalPropertyUnder40k,
    noCharge,
  ],
];

export const getExceptions = (
  searchContext: ISearchContext,
): IRuleMapping | undefined => exceptions.find(([assertion]) => assertion(searchContext));
